<template>
	<!-- 过渡动画 -->
	<transition name="fade">
		<div class="img-view" @click="bigImg">
			<!-- 遮罩层 -->
			<div class="img-layer"></div>
			<div class="img">
				<div class="infos">
					<span style="color:white;margin-right:10px;">学校：{{school}}</span>
					<span style="color:white;margin-right:10px;">姓名：{{name}}</span>
					<span style="color:white;margin-right:10px;">学号：{{campusId}}</span>
				</div>
				<img :src="imgSrc" @click.stop="myclick()" id="myImg">
			</div>
		</div>
	</transition>
</template>
<script>
	export default {
		props: ["imgSrc", "school", "name", "campusId"],
		data() {
			return {
				deg: 0
			};
		},
		methods: {
			bigImg() {
				// 发送事件
				this.$emit("clickit");
			},
			myclick() {
				let img = document.getElementById("myImg");
				this.deg += 90;
				img.style.transform = "rotate(" + this.deg + "deg)";
			}
		}
	};
</script>
<style scoped>
	/*动画*/

	.fade-enter-active,
	.fade-leave-active {
		transition: all 0.2s linear;
		transform: translate3D(0, 0, 0);
	}

	.fade-enter,
	.fade-leave-active {
		transform: translate3D(100%, 0, 0);
	}

	/* bigimg */

	.img-view {
		/* position: inherit; */
		width: 100%;
		height: 100%;
		cursor: pointer;
	}

	/*遮罩层样式*/

	.img-view .img-layer {
		position: fixed;
		z-index: 999;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.7);
		width: 100%;
		height: 100%;
		overflow: hidden;
		cursor: pointer;
	}

	/*不限制图片大小，实现居中*/

	.img-view .img div {
		max-width: 100%;
		display: block;
		position: absolute;
		left: 0;
		right: 0;
		top: 0px;
		text-align: center;
		z-index: 1000;
	}

	.img-view .img .infos {
		z-index: 10000;
	}

	.img-view .img img {
		max-width: 50%;
		display: block;
		position: absolute;
		left: 0;
		right: 0;
		top: 36px;
		margin: auto;
		z-index: 1000;
	}
</style>


// WEBPACK FOOTER //
// BigImg.vue?2105e7d4